var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.59375 14.4326C3.17188 12.6553 0 8.41699 0 6.01074C0 3.1123 2.32422 0.760742 5.25 0.760742C8.14844 0.760742 10.5 3.1123 10.5 6.01074C10.5 8.41699 7.30078 12.6553 5.87891 14.4326C5.55078 14.8428 4.92188 14.8428 4.59375 14.4326ZM5.25 7.76074C6.20703 7.76074 7 6.99512 7 6.01074C7 5.05371 6.20703 4.26074 5.25 4.26074C4.26562 4.26074 3.5 5.05371 3.5 6.01074C3.5 6.99512 4.26562 7.76074 5.25 7.76074Z",
    fill: "#F64A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.727678819ac99773e5934cb4aa857e1b.svg";
export { ForwardRef as ReactComponent };